<div class="calculator-container">
  <ngx-app-bar
    class="w-100"
    [title]="'ماشین حساب'"
    [rightButton]="{
      icon: 'arrow-right',
      style: 'neutral-link',
      mode: 'icon-only',
      size: 'medium',
    }"
    (onRightButtonClick)="onBackHandler()"
  />

  <div class="calculator-content">
    <div class="calculator-description">
      <p>برای محاسبه سود صندوق‌ها در گذشته، بازه زمانی و مبلغ سرمایه‌گذاری مورد نظر را وارد کنید :</p>
    </div>
    <div
      class="calculator-form"
      [formGroup]="form"
    >
      <div class="calculator-date-picker">
        <ui-form-field
          label="از تاریخ"
          [isNumericKeyboard]="true"
          formControlName="fromDate"
          [hasCleaner]="true"
          type="date"
          dateRange="past"
          [customDateRange]="fromDateRange"
          (ngModelChange)="fromDateChanged($event)"
        ></ui-form-field>
        <ui-form-field
          label="تا تاریخ"
          [isNumericKeyboard]="true"
          formControlName="toDate"
          [hasCleaner]="true"
          type="date"
          [customDateRange]="toDateRange"
          (ngModelChange)="toDateChanged($event)"
        ></ui-form-field>
      </div>
      <div>
        <ui-form-field
          label="مبلغ مورد نظر خود را وارد کنید."
          [isNumericKeyboard]="true"
          formControlName="amount"
          [hasCleaner]="true"
          type="amount"
        ></ui-form-field>
      </div>
      <div class="calculator-button">
        <ngx-button
          class="btn-retry"
          [fullWidth]="true"
          (clickHandler)="onCalculate()"
          [brandButton]="true"
          [disabled]="!form.valid"
        >
          محاسبه سود
        </ngx-button>
      </div>
    </div>
    @if (isLoading) {
      <app-spinner></app-spinner>
    }
    @if (funds.length) {
      <div class="calculator-funds">
        <app-available-funds [funds]="funds"></app-available-funds>
      </div>
    }
  </div>
</div>
